const colors = {
  darkGreen: 'hsl(140,50%,45%)',
  semiDarkGreen: 'hsl(140,50%,60%)',
  lightGreen: 'hsl(140,50%,80%)',
  darkYellow: 'hsl(50,80%,50%)',
  semiDarkYellow: 'hsl(55,80%,60%)',
  lightYellow: 'hsl(55,80%,80%)',
  darkRed: 'hsl(0, 100%, 40%)',
  semiDarkRed: 'hsl(0, 100%, 60%)',
  lightRed: 'hsl(0, 100%, 80%)',
  slateGrey: 'slategrey',
  successGreen: '#4caf50',
  unlinkGrey: '#a0a0a0',
  gainsboro: 'gainsboro',
  lightGrey: 'rgba(0, 0, 0, 0.54)',
};

export default colors;
